import { useContext } from 'react';
import UserContext, { useFavoritesIds } from '~/context/common/UserContext';
import useIsHydrated from '~/hooks/common/useIsHydrated';

const noFavoriteIds: Array<number> = [];

// Keeps hearts in server HTML and the hydration render identical: server favorites until UserContext loads them;
// without server favorites, no hearts while hydrating, then the live list.
export default function useFavoriteIdsWithInitial(
  initialFavoriteIds?: Array<number>
) {
  const {
    favorites: { hasEverLoaded }
  } = useContext(UserContext);
  const favoriteIds = useFavoritesIds();
  const isHydrated = useIsHydrated();

  if (initialFavoriteIds) {
    return hasEverLoaded ? favoriteIds : initialFavoriteIds;
  }

  return isHydrated ? favoriteIds : noFavoriteIds;
}
